import { FALLBACK_LOCALE, type SupportedLocale } from './detect'

/**
 * Detecção de chaves ausentes (req. 30/32).
 *
 * Em produção o vue-i18n resolve via fallback pt-BR e o usuário nunca vê
 * a chave crua. Aqui registramos o ocorrido para auditoria: em dev,
 * avisamos no console e acumulamos num buffer exposto em
 * `window.__LOCZI_MISSING_KEYS__` para o relatório de cobertura.
 */

export interface MissingEntry {
  locale: string
  key: string
  instance?: unknown
}

const buffer: MissingEntry[] = []

declare global {
  // eslint-disable-next-line no-var
  var __LOCZI_MISSING_KEYS__: MissingEntry[] | undefined
}

export function reportMissingKey(locale: string, key: string): void {
  buffer.push({ locale, key })

  if (typeof window !== 'undefined') {
    window.__LOCZI_MISSING_KEYS__ = buffer
  }

  if (import.meta.env?.DEV) {
    console.warn(`[i18n] missing "${key}" for locale "${locale}" — fallback: ${FALLBACK_LOCALE}`)
  }
}

export function getMissingKeys(): readonly MissingEntry[] {
  return buffer
}

/**
 * Handler registrado no createI18n — chamado pelo vue-i18n em cada miss.
 * Retorna void para a cadeia de fallback (→ pt-BR) resolver o valor;
 * nunca devolve a chave crua (req. 32).
 */
export function missingHandler(locale: string | number, key: string): void {
  reportMissingKey(String(locale), key)
}
